// extracted by mini-css-extract-plugin
export default {"lds-ring":"Loading_lds-ring__5xVlk"};